import { render, staticRenderFns } from "./GroupGoods.vue?vue&type=template&id=4ddcfa8e"
import script from "./GroupGoods.vue?vue&type=script&lang=js"
export * from "./GroupGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports